module.exports = {
  WEBDRIVERIO_INPUT_ELEMENT: '.b-agent-demo_input #query',
  WEBDRIVERIO_OUTPUT_ELEMENT: '//div[@class=\'b-agent-demo\']//div[@class=\'server-response\' and not(contains(.,\'...\'))]'
}
